import AjaxUtils from './ajaxUtils';

export const patchCalendarIntegrationAdvancedSettings = async (userId, data) => AjaxUtils.patch(`${envConfig.PLATFORM_SERVER_URL}/v2/lusha-calendar/settings/${userId}`, data, true);

export const fetchUserCalendarSettings = async id => AjaxUtils.get(`${envConfig.PLATFORM_SERVER_URL}/v2/lusha-calendar/settings/${id}`, true);
